































































































import Vue from "vue";
import Component, {mixins} from "vue-class-component"
import {State} from "vuex-class"
import Pagination, {PaginationInput} from "@/modules/core/model/pagination"
import Guide from "@/modules/support/model/Guide"
import _ from 'lodash'
import CategorySelector from "@/modules/support/components/Guide/CategorySelector.vue"
import {DateMixin} from "@/modules/core/date"
import {VDataTableOptions} from "@/types";
import {Watch} from "vue-property-decorator";

/**
 * Lista de guías
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component({
    components: {CategorySelector}
})
export default class GuideList extends mixins(DateMixin) {
    /**
     * Paginación de guías actualmente cargada por el servidor
     */
    @State(state => state.support.guidePagination)
    public pagination: Pagination<Guide>

    @State(state => state.support.guideViewPaginationInput)
    public input: PaginationInput

    public loading = false

    /**
     * Opciones de la tabla
     */
    tableOptions: Partial<VDataTableOptions> = {}

    @Watch('tableOptions')
    async watchTableOptions (options: VDataTableOptions) {
        this.updatePaginationInputOption({
            page: options.page,
            recordsPerPage: options.itemsPerPage,
        })

        await this.loadPagination()
    }

    created() {
        this.tableOptions.itemsPerPage = this.input.recordsPerPage
    }

    /**
     * Actualiza un filtro de búsqueda y recarga la paginación
     */
    public async updateFilter(field: string, value: any) {
        this.$store.commit('support/UPDATE_PAGINATION_INPUT_FILTER', {field, value})
        await this.loadPagination()
    }

    /**
     * Actualiza una de las opciones de la paginación
     *
     * @param input
     */
    public updatePaginationInputOption(input: PaginationInput) {
        this.$store.commit('support/UPDATE_GUIDE_PAGINATION_INPUT_OPTIONS', input)
    }

    public async loadPagination() {
        this.loading = true
        await this.$store.dispatch('support/loadGuidePagination')

        this.loading = false
    }

    /**
     * Actualiza un filtro de la paginación con un cierto delay
     */
    public updateDebounceFilter = _.debounce(function (this: GuideList, {field, value}) {
        this.updateFilter(field, value)
    }, 400)
}
